// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-item.active[data-v-f924d106] {\n    background-color: #272b30;\n}\n.is-invalid .dropdown[data-v-f924d106] {\n    border: 1px solid #ee5f5b;\n}\n", ""]);
// Exports
module.exports = exports;
